import { apiSlice } from "../features/api/apiSlice";
import messagesReducer from "../features/chatbot/messagesSlice";
import { Socket } from "../common/utils/Socket";
import { makeSocketMiddleware } from "../features/chatbot/socketMiddleware";
import { configureStore } from "@reduxjs/toolkit";

const BACKEND_URL = process.env.REACT_APP_BACKEND_WS || "ws://localhost:8000";
const socketMiddleware = makeSocketMiddleware(new Socket(`${BACKEND_URL}/ws/chat/`));

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        messages: messagesReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware).concat(socketMiddleware),
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
